import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts'
import { PageLoader } from './PageLoader'

interface ProtectedRouteProps {
  children: React.ReactNode
}

// Protected route wrapper - requires authentication
export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return <PageLoader />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
